/* KX JS - tone demo, dock, sticky bars, PDP gallery/variants/viewer, delivery estimate. No libraries. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Tone demo ---------- */
  var TONES = { warm: 'rgb(255,180,107)', neutral: 'rgb(255,209,163)', cool: 'rgb(240,246,255)' };
  var WASH = { warm: 'rgba(255,180,107,.38)', neutral: 'rgba(255,209,163,.30)', cool: 'rgba(178,198,255,.30)' };
  $$('[data-kx-tone]').forEach(function (root) {
    var wall = $('.kx-tone__wall', root);
    var line = $('[data-kx-line]', root);
    var dim = $('[data-kx-dim]', root);
    var map = { warm: root.getAttribute('data-kx-lwarm'), neutral: root.getAttribute('data-kx-lneutral'), cool: root.getAttribute('data-kx-lcool') };
    function set(tone) {
      if (wall) { wall.style.setProperty('--kx-tone', TONES[tone]); wall.style.setProperty('--kx-wash', WASH[tone]); }
      if (line && map[tone]) line.textContent = map[tone];
      $$('[data-kx-tone-btn]', root).forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-kx-tone-btn') === tone ? 'true' : 'false');
      });
    }
    $$('[data-kx-tone-btn]', root).forEach(function (b) {
      b.addEventListener('click', function () { set(b.getAttribute('data-kx-tone-btn')); });
    });
    if (dim) dim.addEventListener('input', function () {
      if (wall) wall.style.setProperty('--kx-dim', (dim.value / 100).toFixed(2));
    });
    set('warm');
  });

  /* ---------- Sticky dock / PDP bar ---------- */
  var footVisible = false;
  (function () {
    var foot = $('footer');
    if (!foot || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        footVisible = e.isIntersecting;
        $$('[data-kx-dock].is-on,[data-kx-pdpbar].is-on').forEach(function (b) {
          if (footVisible) b.classList.remove('is-on');
        });
      });
    }, { threshold: 0 }).observe(foot);
  })();
  function watch(sel) {
    var bar = $(sel);
    var anchor = $('[data-kx-sticky-after]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', past && !footVisible);
      });
    }, { threshold: 0 }).observe(anchor);
  }
  watch('[data-kx-dock]');
  watch('[data-kx-pdpbar]');

  /* ---------- PDP delivery estimate (business days, estimate only) ---------- */
  (function () {
    var el = $('[data-kx-delivery]');
    if (!el) return;
    var cc = ((window.Shopify && Shopify.country) || 'US').toUpperCase();
    var map = { US: el.getAttribute('data-kx-us'), GB: el.getAttribute('data-kx-gb'), IT: el.getAttribute('data-kx-it'), FR: el.getAttribute('data-kx-fr') };
    var proc = (el.getAttribute('data-kx-proc') || '1,2').split(',');
    var tr = (map[cc] || '').split(',');
    if (!tr[0]) { el.style.display = 'none'; return; }
    function addBiz(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; }
    var now = new Date();
    var from = addBiz(now, parseInt(proc[0], 10) + parseInt(tr[0], 10));
    var to = addBiz(now, parseInt(proc[1] || proc[0], 10) + parseInt(tr[1] || tr[0], 10));
    var fmt = function (d) { return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }); };
    el.textContent = (el.getAttribute('data-kx-label') || '') + ' ' + fmt(from) + ' - ' + fmt(to);
  })();

  /* ---------- Quantity steppers ---------- */
  $$('form.product_form input.quantity[name="quantity"]').forEach(function (inp) {
    if (inp.closest('.kx-qty')) return;
    var wrap = document.createElement('span'); wrap.className = 'kx-qty';
    inp.parentNode.insertBefore(wrap, inp); wrap.appendChild(inp);
    [['−', -1], ['+', 1]].forEach(function (cfg) {
      var b = document.createElement('button'); b.type = 'button'; b.textContent = cfg[0];
      b.setAttribute('aria-label', cfg[1] > 0 ? 'Increase quantity' : 'Decrease quantity');
      b.addEventListener('click', function () {
        var v = (parseInt(inp.value, 10) || 1) + cfg[1];
        var min = parseInt(inp.getAttribute('min') || '1', 10), max = parseInt(inp.getAttribute('max') || '0', 10);
        if (v < min) v = min; if (max > 0 && v > max) v = max; inp.value = v;
      });
      if (cfg[1] > 0) wrap.appendChild(b); else wrap.insertBefore(b, inp);
    });
  });

  /* ---------- PDP: gallery + viewer + variants + sticky bar ---------- */
  var pdp = $('[data-kx-pdp]');
  if (pdp) {
    var form = $('form.product_form', pdp);
    var variants = [];
    try { variants = JSON.parse($('[data-kx-variants]', pdp).textContent); } catch (e) {}
    var slides = $$('.kx-slides > li', pdp);
    var thumbs = $$('.kx-thumbs button', pdp);
    var rail = $('.kx-thumbs', pdp);
    var curEl = $('[data-kx-cur]', pdp);
    var barImg = $('[data-kx-barimg]', pdp);
    var gm = $('.kx-gal-main', pdp);
    var cur = 0;
    slides.forEach(function (li, i) { if (li.classList.contains('is-active')) cur = i; });

    function show(i) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length; cur = i;
      slides.forEach(function (li, k) { li.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (b, k) { b.classList.toggle('is-active', k === i); });
      $$('img.featured_image', pdp).forEach(function (x) { x.classList.remove('featured_image'); });
      var im = $('img', slides[i]);
      if (im) { im.classList.add('featured_image'); if (barImg) barImg.src = im.currentSrc || im.src; }
      if (curEl) curEl.textContent = i + 1;
      var tb = thumbs[i];
      if (rail && tb && tb.parentNode) {
        var li = tb.parentNode;
        if (rail.scrollWidth > rail.clientWidth + 2) rail.scrollTo({ left: li.offsetLeft - (rail.clientWidth - li.offsetWidth) / 2, behavior: 'smooth' });
        else if (rail.scrollHeight > rail.clientHeight + 2) rail.scrollTo({ top: li.offsetTop - (rail.clientHeight - li.offsetHeight) / 2, behavior: 'smooth' });
      }
    }
    show(cur);
    $$('[data-kx-gprev]', pdp).forEach(function (b) { b.addEventListener('click', function () { show(cur - 1); }); });
    $$('[data-kx-gnext]', pdp).forEach(function (b) { b.addEventListener('click', function () { show(cur + 1); }); });
    thumbs.forEach(function (b) { b.addEventListener('click', function () { show(parseInt(b.getAttribute('data-kx-thumb'), 10) || 0); }); });
    if (gm) {
      var sx = null;
      gm.addEventListener('touchstart', function (ev) { sx = ev.touches[0].clientX; }, { passive: true });
      gm.addEventListener('touchend', function (ev) {
        if (sx === null) return;
        var dx = ev.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }

    var vdlg = $('dialog[data-kx-viewer]', pdp);
    var viewer = (vdlg && window.kxViewer) ? window.kxViewer(vdlg) : null;
    $$('[data-kx-zoom]', pdp).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!viewer) return;
        var idx = slides.indexOf(btn.closest('li')); if (idx < 0) idx = 0;
        var im = $('img', btn);
        viewer.open(idx, { from: gm || btn, placeholder: im && (im.currentSrc || im.src), onClose: function (k) { show(k); } });
      });
    });

    function pick() {
      if (!form) return null;
      var opts = $$('input[type=radio][name^="option-"]:checked', form).map(function (r) { return r.value; });
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.options.length === opts.length && v.options.every(function (o, j) { return o === opts[j]; })) return v;
      }
      return null;
    }
    function imageIndex(v) {
      var idx = -1;
      slides.forEach(function (li, i) { if (v.image && String(li.getAttribute('data-image-id')) === String(v.image)) idx = i; });
      if (idx >= 0) return idx;
      var label = ((v.options && v.options[0]) || v.title || '').toLowerCase();
      var gold = /gold|dor|oro/.test(label), black = /black|noir|nero/.test(label);
      slides.forEach(function (li, i) {
        if (idx >= 0) return;
        var im = $('img', li); var alt = ((im && im.alt) || '').toLowerCase();
        if ((gold && /gold|dor|oro/.test(alt)) || (black && /black|noir|nero/.test(alt))) idx = i;
      });
      return idx;
    }
    function apply(v, updateUrl) {
      if (!v) return;
      var id = $('input[name=id]', form); if (id) id.value = v.id;
      var price = $('[data-kx-price]', pdp); if (price) price.textContent = v.price;
      var cmp = $('[data-kx-compare]', pdp); if (cmp) cmp.textContent = v.compare || '';
      var per = $('[data-kx-per-price]', pdp); if (per) per.textContent = v.half;
      var sku = $('[data-kx-sku]', pdp); if (sku && v.sku) sku.textContent = v.sku;
      var atc = $('.kx-atc', pdp);
      if (atc) { var t = $('.text', atc); if (t) t.textContent = (atc.getAttribute('data-kx-label') || '') + ' - ' + v.price; }
      var bp = $('[data-kx-barprice]', pdp); if (bp) bp.textContent = v.price;
      var bf = $('[data-kx-barfinish]', pdp); if (bf) bf.textContent = v.title;
      var idx = imageIndex(v); if (idx >= 0) show(idx);
      if (updateUrl) { try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); } catch (e) {} }
    }
    if (form) {
      $$('input[type=radio][name^="option-"]', form).forEach(function (r) {
        r.addEventListener('change', function () { apply(pick(), true); });
      });
    }
    var first = pick(); if (first) apply(first, false);

    $$('[data-kx-barpgo]', pdp).forEach(function (b) {
      b.addEventListener('click', function () {
        var atc = $('.kx-atc', pdp);
        if (atc && !atc.disabled && atc.offsetParent !== null) atc.click();
        else { var t = document.getElementById('kx-buy'); if (t) t.scrollIntoView({ behavior: 'smooth' }); }
      });
    });
  }

  /* ---------- PDP: defer the Judge.me review widget until near viewport ---------- */
  (function () {
    var host = $('[data-kx-reviews]');
    var tpl = document.getElementById('kx-reviews-template');
    if (!host || !tpl || host.getAttribute('data-kx-reviews-loaded')) return;
    var loaded = false;
    function loadReviews() {
      if (loaded) return;
      loaded = true;
      host.setAttribute('data-kx-reviews-loaded', '1');
      var frag;
      try { frag = tpl.content ? tpl.content.cloneNode(true) : (function () { var d = document.createElement('div'); d.innerHTML = tpl.innerHTML; return d; })(); } catch (e) { return; }
      host.innerHTML = '';
      host.appendChild(frag);
      var widget = $('.jdgm-review-widget', host);
      if (!widget) return;
      var entry = widget.getAttribute('data-entry-point');
      var key = widget.getAttribute('data-entry-key');
      var base = window.jdgm && window.jdgm.CDN_BASE_URL;
      if (!entry || !key || !base) return;
      var src = base + entry;
      function loadCss(manifest, k, seen) {
        if (!manifest[k] || seen[k]) return;
        seen[k] = 1;
        (manifest[k].css || []).forEach(function (href) {
          var url = base + href;
          if (!document.querySelector('link[href="' + url + '"]')) {
            var link = document.createElement('link');
            link.rel = 'stylesheet'; link.href = url;
            document.head.appendChild(link);
          }
        });
        (manifest[k].imports || []).forEach(function (next) { loadCss(manifest, next, seen); });
      }
      fetch(base + 'manifest.json?v=' + Date.now())
        .then(function (r) { return r.json(); })
        .then(function (manifest) { loadCss(manifest, key, {}); })
        .catch(function () {})
        .then(function () {
          if (document.querySelector('script[src="' + src + '"]')) return;
          var s = document.createElement('script');
          s.type = 'module'; s.src = src;
          s.onerror = function () { host.innerHTML = '<p class="kx-reviews-loading">Reviews could not be loaded.</p>'; };
          document.head.appendChild(s);
        });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); loadReviews(); } });
      }, { rootMargin: '800px 0px' });
      io.observe(host);
    } else { loadReviews(); }
  })();
})();